import { Block } from "@block";
import { spacing } from "@styles/spacing";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Caption, useTheme } from "react-native-paper";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";

const FooterHome = () => {
  const { colors } = useTheme();
  const [themeColors] = React.useState<string>("rgba(101, 96, 86, 1)");
  const { t } = useTranslation();
  const { styles } = useStyles();

  const colorStyle = {
    color: colors.whiteText,
  };

  return (
    <React.Fragment>
      <Block pv={spacing.small} row middle ph={spacing.huge} bg={themeColors}>
        <Block flex={1} center middle>
          <Caption children={t("COMMON_PHIEN_BAN_IB")} style={[colorStyle, styles("textStyle")]} />
        </Block>
      </Block>
    </React.Fragment>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    textStyle: {
      textAlign: "center",
      fontSize: 10,
    },
  },
  {
    [DEVICE_SIZES.EXTRA_SMALL_DEVICE]: {
      textStyle: {
        fontSize: 8,
      },
    },
  },
);

export default FooterHome;
